// extracted by mini-css-extract-plugin
module.exports = {"statusLoader":"antd-pro-pages-admin-shipments-admin-shipment-view-scan-status-list-style-statusLoader"};